// add negative signs to numbers based on "sign"
export default function signAssign(sign, a, b, c) {
    // add slashes to environment
    if (sign > 3 && typeof c === "undefined") {
        throw "sign > 3 but only 2 values given";
    }
    let twoMode = true;
    if (sign > 3) {
        c *= -1;
        sign = sign % 4;
        twoMode = false;
    }
    if (sign % 2 == 1) {
        b *= -1;
    }
    if (sign > 1) {
        a *= -1;
    }
    if (twoMode) {
        return [a, b];
    }
    else {
        return [a, b, c];
    }
}
